import { NAV_MENU_TYPE } from '../../types';

const RD_PLG_HIDDEN_MENU_TYPES = new Set([
    NAV_MENU_TYPE.AGENT_LIST,
    NAV_MENU_TYPE.MONITOR,
    NAV_MENU_TYPE.COMMUNITY
]);

export function isMenuVisibleForPlgHome(menuType: NAV_MENU_TYPE, plgHome: unknown): boolean {
    return plgHome !== 'RD' || !RD_PLG_HIDDEN_MENU_TYPES.has(menuType);
}
